import React, {FC, ImgHTMLAttributes} from "react";
import logoBlack from '../../../../assets/images/svg/logo-black.svg';
import logoWhite from '../../../../assets/images/svg/logo-white.svg';
import logoGreen from '../../../../assets/images/svg/logo-new.svg';
import logoMobile from '../../../../assets/images/svg/cone-mobile.svg';
import logoText from '../../../../assets/images/svg/logo-text-finance.svg';
import Image from "../Image";

export enum LogoType {
    GREEN = logoGreen,
    WHITE = logoWhite,
    BLACK = logoBlack,
    MOBILE = logoMobile,
    LOGO_TEXT = logoText,
}

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
    type: LogoType
}

const LogoImage: FC<Props> = ({type, ...props}) => {
  return (
    <Image {...props} src={type.toString()} alt={"Лого"} />
  );
};

export default LogoImage;